// ===================================================
// ФАЙЛ: frontend/src/store/index.js
// ИСПРАВЛЕННАЯ ВЕРСИЯ: Правильные импорты
// ===================================================
import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import productsSlice from './productsSlice';
import warehousesSlice from './warehousesSlice';
// Wave 7: syncSlice removed with SyncPage (UI → /exchange-log)

export const store = configureStore({
  reducer: {
    auth: authSlice,
    products: productsSlice,
    warehouses: warehousesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// TypeScript types (для использования в TypeScript файлах):
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
